import SvgIcon from "../../utils/Icon";
import { ReactComponent as Archivo } from "../../assets/icons/archivo.svg";
import InputFile from "../../utils/InputFile";
import { useState } from "react";

const CompleteDocuments = () => {
    const [files, setFiles] = useState({ cedulaPDF: null });

    const onHandleFileChange = (ev) => {
        const { name, files: selectedFiles } = ev.target;
        setFiles((prevFiles) => ({
            ...prevFiles,
            [name]: selectedFiles[0]
        }));
    };

    return (
        <div className="rounded-2xl overflow-hidden shadow-lg border border-gray-200/80">
            <div className="flex items-center px-6 py-4 bg-gradient-to-r from-[#1f94c2ff] to-[#2aa8d4]">
                <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-white/20 mr-3">
                    <SvgIcon Icon={Archivo} className="w-5 h-5 shrink-0 text-white" />
                </div>
                <h2 className="text-lg font-semibold text-white">
                    Documento de identidad
                </h2>
            </div>
            <div className="bg-white px-6 py-5 border-t border-gray-100">
                <p className="text-sm text-gray-500 mb-4">
                    PDF o imagen (JPG, PNG). Tamaño máximo 10MB.
                </p>
                <div className="rounded-xl border-2 border-dashed border-gray-200 bg-gray-50/50 hover:border-[#1f94c2ff]/40 hover:bg-blue-50/30 transition-colors p-4">
                    <InputFile 
                        accept=".pdf,.jpg,.jpeg,.png" 
                        name="cedulaPDF" 
                        fileName={files.cedulaPDF?.name} 
                        onChange={onHandleFileChange}
                        placeholder="Sube tu documento de identidad (PDF o imagen, máximo 10MB)"
                    />
                </div>
            </div>
        </div>
    );
};

export default CompleteDocuments;